export const ASIN_REGEX = /^[A-Z0-9]{10}$/i;

export const isValidAsin = (value: string): boolean =>
  ASIN_REGEX.test(value.trim());
